export const BRANCH_PARAM = "branch";
export const ALLAHABAD_BRANCH_VALUE = "allahabad";
export const ALLAHABAD_WHATSAPP_NUMBER = "919243388419";

export const isAllahabadBranch = (search = "") => {
  const params = new URLSearchParams(search);
  return params.get(BRANCH_PARAM) === ALLAHABAD_BRANCH_VALUE;
};

export const buildPathWithBranch = (pathname, isEnabled) => {
  if (!isEnabled) return pathname;

  const separator = pathname.includes("?") ? "&" : "?";
  return `${pathname}${separator}${BRANCH_PARAM}=${ALLAHABAD_BRANCH_VALUE}`;
};

export const resolveWhatsappNumber = (defaultNumber, search = "") =>
  isAllahabadBranch(search) ? ALLAHABAD_WHATSAPP_NUMBER : defaultNumber;
